"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var common_1 = require("docs/common");
exports.PropertiesDrawerItem = function (props) { return (React.createElement(common_1.PropertyTable, null,
    React.createElement(common_1.Property, { name: "iconName", type: "string", description: "Name of the icon that will appear in the left side of a Drawer Item." }),
    React.createElement(common_1.Property, { name: "text", type: "string", description: "Text inside the item." }),
    React.createElement(common_1.Property, { name: "subitem", type: "bool", description: "If is true, a padding-left will be set." }))); };
exports.PropertiesDrawerItem.displayName = 'PropertiesDrawerItem';



//////////////////
// WEBPACK FOOTER
// ./src/docs/pages/ComponentDrawerItemPage/PropertiesDrawerItem.tsx
// module id = 657
// module chunks = 0